<style>
    .disable-whole-div__cover {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 1;
        background-color:transparent;
        opacity: 0.3;
    }
    .py-10 {
        padding-top: 10px !important;
        padding-bottom: 10px !important;
    }

    </style>

<div class="box ibox box-info margin-bottom-none">
    <!-- <div class="disable-whole-div__cover" [hidden]="disableControl"></div> -->
       
    <ng-container *ngIf="!isHeaderTop" [ngTemplateOutlet]="noteHeader"></ng-container>

            <div class="py-10 d-none d-md-block" *ngIf="NoteList && NoteList.length > 0">
                 <table width="100%" style="width:100%;table-layout: fixed;" id="noteTable">

                     <tbody><tr *ngFor="let item of NoteList.slice().reverse();let index=index">
                        <td align="center" width="8%" valign="top">
                          {{item.createdOn | date:'dd/MM/yyyy'}}
                        </td>

                        <td align="center" width="7%" valign="top">
                        {{item.createdOn | date:'HH:mm'}}
                        </td>

                        <td align="center" width="10%"  class="text-center" *ngIf="showHours==true" valign="top">
                            {{(getNoteHour(item.description) | number:'2.2')}}
                            <span *ngIf="getNoteHour(item.description) !=''"> hr </span>
                            <span *ngIf="getNoteHour(item.description) ==''"> N/A </span>
                        </td>

                        <td align="center" class="text-center" width="15%" valign="top">
                              {{item.createdbyname}}
                        </td>

                         <td align="left" width="auto" >
                             <div style="word-wrap: break-word;margin-bottom:0px;" [innerHTML]="(getNoteDesc(item.description))">
                             </div>
                         </td>
                     </tr>

                     </tbody></table>
             </div>

               <div class="py-10 d-block d-md-none" *ngIf="NoteList && NoteList.length > 0">
                 <table width="100%" style="width:100%;table-layout: fixed;" id="noteTable">

                     <tbody><tr *ngFor="let item of NoteList.slice().reverse();let index=index">
                        <td>
                          {{item.createdOn | date:'dd/MM/yyyy'}}
                        </td>

                        <td>
                        {{item.createdOn | date:'HH:mm'}}
                        </td>

                        <td>
                            {{(getNoteHour(item.description) | number:'2.2')}}
                            <span *ngIf="getNoteHour(item.description) !=''"> hr </span>
                            <span *ngIf="getNoteHour(item.description) ==''"> N/A </span>
                        </td>

                        <td>
                              {{item.createdbyname}}
                        </td>

                         <td>
                             <div style="word-wrap: break-word;margin-bottom:0px;" [innerHTML]="(getNoteDesc(item.description))">
                             </div>
                         </td>
                     </tr>

                     </tbody></table>
             </div>

             <ng-container *ngIf="isHeaderTop" [ngTemplateOutlet]="noteHeader"></ng-container>
              <!-- Template definition -->
<ng-template #noteHeader>
  <div class="box-header" [ngClass]="{'with-border': NoteList?.length > 0}">
    <div class="row">
      <div class="col-sm-11">
        <h3 class="box-title">
          {{ PlusNoteHeader }}
          <button
            style="display: inline-block;"
            (click)="AddNote()"
            class="btn btn-primary no-print btn-label-left center-block btn-xs btn-note"
            type="button"
            [attr.disabled]="disableControl ? 'true' : null"
          >
            <span><i class="fa fa-plus"></i></span>
          </button>
        </h3>
      </div>
      <div class="col-sm-1"></div>
    </div>
  </div>
</ng-template>
             </div>
